import cn from 'classnames'

import './styles.scss'
import { BabyGender } from 'types'
import { MaleIcon, FemaleIcon } from 'components'

interface Props {
  selected: BabyGender
  onChange: (value: string) => void
}

export const SexButtons = ({ selected, onChange }: Props) => {
  return (
    <div className="sex-buttons">
      <button
        tabIndex={-1}
        className={cn('sex-button boy', { active: selected === BabyGender.MALE })}
        onClick={() => onChange(BabyGender.MALE)}
      >
        <MaleIcon /> Мальчик
      </button>
      <button
        tabIndex={-1}
        className={cn('sex-button girl', { active: selected === BabyGender.FEMALE })}
        onClick={() => onChange(BabyGender.FEMALE)}
      >
        <FemaleIcon /> Девочка
      </button>
    </div>
  )
}
